import React from 'react';
import clsx from 'clsx';
import { IProjectItemOverview } from 'common/types/projects';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';

import 'swiper/css/pagination';
import { WorkProjectItem } from './WorkProjectItem';

interface Props {
  projects: IProjectItemOverview[];
  dark?: boolean;
}

export const WorkProjectsOther: React.FC<Props> = ({ projects, dark = true }) => (
  <section
    className={clsx('relative overflow-hidden py-10', {
      'bg-gradient': dark,
      'bg-white': !dark,
    })}
    id="blogItemsLatest">
    <Swiper
      style={{ paddingBottom: 50, paddingLeft: 20, paddingRight: 20 }}
      spaceBetween={10}
      slidesPerView={1}
      modules={[Pagination]}
      pagination={{ clickable: true }}
      breakpoints={{
        600: { slidesPerView: 1 },
        1020: { slidesPerView: 2.2 },
        1600: { slidesPerView: 3.2 },
        2200: { slidesPerView: 3.2 },
      }}>
      {!!projects?.length &&
        projects?.map((project: IProjectItemOverview) => (
          <SwiperSlide key={project.slug}>
            <WorkProjectItem project={project} />
          </SwiperSlide>
        ))}
    </Swiper>
  </section>
);

export default WorkProjectsOther;
